(function () {
  const MIN_AGE = 18;                       // cambia se ti serve
  const COOKIE_NAME = 'age_verified';
  const COOKIE_DAYS = 30;                   // durata “ricorda”
  const REDIRECT_URL = 'https://www.google.com';

  const $gate  = document.getElementById('age-gate');
  if (!$gate) return;

  const $input = document.getElementById('age-gate-year');

  // --- cookie helpers ---
  const setCookie = (name, value, days) => {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  };
  const getCookie = (name) => {
    return (`; ${document.cookie}`).split(`; ${name}=`).pop().split(';')[0] || '';
  };

  const isVerified = () => getCookie(COOKIE_NAME) === '1' || localStorage.getItem(COOKIE_NAME) === '1';

  const openGate = () => {
    $gate.hidden = false;
    document.body.classList.add('age-gate-open');
    // focus input con un piccolo delay per iOS
    setTimeout(() => $input && $input.focus(), 50);
  };

  const closeGate = () => {
    $gate.hidden = true;
    document.body.classList.remove('age-gate-open');
  };

  const calcIsAdultFromYear = (yyyy) => {
    const year = parseInt(yyyy, 10);
    if (!year || yyyy.length !== 4) return null; // incompleto
    const now = new Date();
    const age = now.getFullYear() - year;
    return age >= MIN_AGE;
  };

  const approve = () => {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    try { localStorage.setItem(COOKIE_NAME, '1'); } catch(e){}
    closeGate();
  };

  const deny = () => {
    // opzionale: segna come denied per evitare loop se back
    try { sessionStorage.setItem('age_denied', '1'); } catch(e){}
    window.location.href = REDIRECT_URL;
  };

  // Blocca ESC per non chiudere
  $gate.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') e.preventDefault();
  });

  // Autovalidazione mentre digiti (niente invio)
  $input.addEventListener('input', () => {
    // tieni solo numeri
    $input.value = $input.value.replace(/\D/g, '').slice(0, 4);
    const state = calcIsAdultFromYear($input.value);
    if (state === null) return; // non ancora 4 cifre

    if (state) {
      approve();
    } else {
      deny();
    }
  });

  // Mostra solo se non già verificato
  if (!isVerified()) {
    openGate();
  }
})();
